// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://acrssamebkljbaskqkki.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFjcnNzYW1lYmtsamJhc2txa2tpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc0MzY2NTgsImV4cCI6MjA3MzAxMjY1OH0.0vSSHe_bqoJPOo0MMwVDr6mOED4raTtJtFNd_SKt9dY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});